export * from './IconCaution';
export { default as IconCaution } from './IconCaution';
